import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import useDestinations from '../../../../hooks/useDestinations';
import { fetchDestinationNamesAC } from '../../../../../redux/actions/destinations/destinations.ac';
import { searchAttractions } from '../../../../../redux/api/attractions.api';
import { fetchAttractionsAC } from '../../../../../redux/actions/attractions/attractions.ac';

import { AutoComplete, Button, Empty, Form, Input, List, Select, Spin } from 'antd';
import {
    PlusOutlined, ExportOutlined
} from '@ant-design/icons';

import { attractionTypes, weatherTypes } from '../../../../Constants/itemTypes';
import useAttractions from '../../../../hooks/useAttractions';
import ReactQuill from 'react-quill';
import { DEFAULT_THUMBNAIL } from '../../../../Constants/otherConstsnts';
import useMyProfile from '../../../../hooks/useMyProfile';
import { ADMIN, SUPER_ADMIN } from '../../../../Constants/roles';

const { Search } = Input;

const getOptionName = (value) => {
    return value
        .toLowerCase()
        .replace(/_./g, (match) => ' ' + match.charAt(1).toUpperCase())
        .replace(/^\w/, (c) => c.toUpperCase());
};


const weatherOptions = Object.keys(weatherTypes).map(key => {
    return {
        label: getOptionName(weatherTypes[key]),
        value: key
    };
});

const attractionOptions = Object.keys(attractionTypes).map(key => {
    return {
        label: getOptionName(attractionTypes[key]),
        value: key
    };
});


const Attractions = () => {
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [searchResults, setSearchResults] = useState([])
    const [isSearchLoading, setIsSearchLoading] = useState(false)
    const destinations = useDestinations()
    const attractions = useAttractions().attractions
    const dispatch = useDispatch();
    const destinationNames = destinations.destinationNames
    const navigate = useNavigate();
    const [filterValues, setFilterValues] = useState({})
    const myProfile = useMyProfile().userProfile

    useEffect(() => {
        if (destinationNames?.length === 0) {
            dispatch(fetchDestinationNamesAC())
        }

        handleFetchAttractions(1, {})
    }, [])

    const destinationOptions = Object.keys(destinationNames).map(key => {
        return {
            label: getOptionName(destinationNames[key].destinationName),
            value: destinationNames[key].id
        };
    });

    const handleSearch = async (value) => {
        setIsSearchLoading(true)
        try {
            const response = await searchAttractions(value)
            addSearchResult(response.data)
        } catch (error) {
            console.error('Search Error', error)
        }

        setIsSearchLoading(false)
    }

    const addSearchResult = (attractions) => {
        const results = attractions.map(attraction => {
            return {
                value: attraction.id,
                label:
                    <div className='result-row' onClick={() => navigate(`/dashboard/tours/attractions/${attraction.id}`)}>
                        <div className='result-row-info'>
                            <h3>{attraction.attractionName}</h3>
                            <p>
                                {attraction.attractionType}
                            </p>
                        </div>
                    </div>
            }
        })

        setSearchResults(results)
    }

    const onChangeSearch = (value) => {
        if (value === '') {
            setSearchResults([])
        }

        if (value.length < 3) {
            return
        }

        handleSearch(value)
    }

    const handleFetchAttractions = async (page, values) => {
        setLoading(true)
        values.page = page
        values.pageSize = 100
        await dispatch(fetchAttractionsAC(values))
        setLoading(false)
    }

    const onFilterSubmit = async (values) => {
        Object.keys(values).forEach(key => (values[key] === undefined || values[key] === '' || values[key] === null) && delete values[key]);
        setFilterValues(values)
        await handleFetchAttractions(1, values)
    }

    return (
        <div className='destinations'>
            <div className='destinations__header'>
                <div className='left'>
                    <h1>Attractions</h1>
                    <AutoComplete
                        dropdownClassName='certain-category-search-dropdown-destinations'
                        dropdownMatchSelectWidth={350}
                        style={{ width: 350 }}
                        options={searchResults}
                    >
                        <Search
                            placeholder="Search"
                            onSearch={handleSearch}
                            enterButton
                            loading={isSearchLoading}
                            onChange={(e) => onChangeSearch(e.target.value)}
                        />
                    </AutoComplete>
                </div>
                {(myProfile?.role === SUPER_ADMIN || myProfile?.role === ADMIN) &&
                    <div className='destinations__header__actions'>
                        <Button type='primary' icon={<PlusOutlined />} onClick={() => navigate('/dashboard/tours/attractions/add')}>
                            Add Attraction
                        </Button>
                    </div>
                }
            </div>

            <div className='destinations__filters'>
                <Form
                    layout='inline'
                    onFinish={onFilterSubmit}
                >
                    <Form.Item
                        name='destinationId'
                    >
                        <Select
                            showSearchsa
                            mode='single'
                            allowClear
                            style={{
                                width: '100%',
                            }}
                            placeholder="Destination Name"
                            options={destinationOptions}
                        />
                    </Form.Item>
                    <Form.Item
                        name='attractionType'
                    >
                        <Select
                            showSearchsa
                            mode='single'
                            allowClear
                            style={{
                                width: '100%',
                            }}
                            placeholder="Attraction Type"
                            options={attractionOptions}
                        />
                    </Form.Item>
                    <Form.Item
                        name='attractionCity'
                    >
                        <Input placeholder='Destination City' />
                    </Form.Item>
                    <Form.Item
                        name='weather'
                    >
                        <Select
                            mode='single'
                            allowClear
                            style={{
                                width: '100%',
                            }}
                            placeholder="Select Weather Type"
                            options={weatherOptions}
                        />
                    </Form.Item>
                    <Form.Item>
                        <Button type='primary' htmlType='submit' loading={loading}>
                            Get Results
                        </Button>
                    </Form.Item>
                </Form>
            </div>


            <div className='destinations__list'>
                {attractions && attractions.length > 0 ?
                    <List
                        loading={loading}
                        pagination={{
                            position: 'bottom',
                            align: 'end',
                            pageSize: 5,
                            showSizeChanger: false,
                            total: attractions[0]?.filteredAttractionCount,
                            current: page,
                            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                            onChange: (page) => { setPage(page); handleFetchAttractions(page, filterValues) }
                        }}
                        dataSource={attractions}
                        renderItem={(item, index) => (
                            <List.Item key={index} className='destination__item'>
                                <div className='left'>
                                    <img src={item?.thumbnailUrl || DEFAULT_THUMBNAIL} alt='attraction' />
                                </div>
                                <div className='right'>
                                    <div className='destination__item__header'>
                                        <h3>{item?.attractionName}</h3>
                                        <Button type='primary' onClick={() => navigate(`/dashboard/tours/attractions/${item.id}`)} icon={<ExportOutlined />}>
                                            View
                                        </Button>
                                    </div>
                                    <ReactQuill
                                        value={item?.attractionDescriptionShort}
                                        readOnly={true}
                                        theme='bubble'
                                    />
                                    <p><strong>Destination: </strong>{
                                        destinationNames.find(destination => destination.id === item?.destinationId)?.destinationName
                                    }</p>
                                    <p><strong>City: </strong>{item?.attractionCity}</p>
                                    <p><strong>Type: </strong>{item?.destinationType || 'N/A'}</p>
                                </div>
                            </List.Item>
                        )}
                    />
                    :
                    <>
                        {
                            loading ?
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    height: '500px'
                                }}>
                                    <Spin size='large' />
                                </div>
                                : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                        }
                    </>
                }
            </div>
        </div>
    )
}

export default Attractions